import React from 'react'
import Typography from '@mui/material/Typography'
import './Footer.css'

function Footer (props) {
  return (
    <div className='footer br2 ph4 pv3'>
      <Typography className="author">Anthony Michael.</Typography>
      <Typography className='copy'>
        <span className="copyright">© 2021 All rights reserved. Designed by</span> Tony Mike
      </Typography>
    </div>
  )
}

export default Footer
